import React from 'react'
import { withRouteData, Head } from 'react-static'
import Gallery from '../components/Gallery'

export default withRouteData(function Album({ album }) {
  return (
    <React.Fragment>
      <Head><title>{album.title}</title></Head>
      <Gallery album={album} />
    </React.Fragment>
  );
})
